module.exports = __webpack_public_path__ + "static/img/best2021.a31f80e.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/best2021.svg
// module id = uUTn
// module chunks = 4